import type { SajuAnalysis } from '../types/input';
import type { ChildrenFortune } from '../types/compatibility';
import type { TenGod } from '../types/ten-gods';

const CHILD_STARS: TenGod[] = ['식신', '상관'];

/**
 * 두 사주의 자녀운을 비교한다.
 *
 * 각 사람의 십신 중 식신/상관 개수를 집계하여 자녀운 호환성을 판정한다.
 */
export function analyzeChildrenFortune(
  analysis1: SajuAnalysis,
  analysis2: SajuAnalysis,
): ChildrenFortune {
  const count1 = countChildStars(analysis1);
  const count2 = countChildStars(analysis2);

  let compatibility: ChildrenFortune['compatibility'];
  if (count1 > 0 && count2 > 0) {
    compatibility = '조화';
  } else if (count1 > 0 || count2 > 0) {
    compatibility = '보통';
  } else {
    compatibility = '부족';
  }
  const description = `자녀운: P1 식상 ${count1}개, P2 식상 ${count2}개 — ${compatibility}`;

  return { person1ChildStars: count1, person2ChildStars: count2, compatibility, description };
}

function countChildStars(analysis: SajuAnalysis): number {
  let count = 0;
  const tg = analysis.tenGods;

  // 천간 십신
  if (CHILD_STARS.includes(tg.year.tenGod)) count++;
  if (CHILD_STARS.includes(tg.month.tenGod)) count++;
  // day is always null (일간=자기 자신)
  if (tg.hour && CHILD_STARS.includes(tg.hour.tenGod)) count++;

  // 지장간 십신
  for (const pos of ['year', 'month', 'day', 'hour'] as const) {
    const hidden = tg.hiddenStems[pos];
    if (hidden) {
      for (const h of hidden) {
        if (CHILD_STARS.includes(h.tenGod)) count++;
      }
    }
  }

  return count;
}
